import React from 'react'
import PropTypes from 'prop-types'
import LeafletMap from 'LeafletMap'

import BaseLink from 'shared/components/BaseLink'
import { boroCodeToName } from 'shared/utilities/languageUtils'
import { getCurrentBuilding } from 'Lookup/utilities'

import './style.scss'

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

const STREET_VIEW_ENABLED = process.env.REACT_APP_STREET_VIEW_ENABLED === 'true'

const StreetViewEmbed = ({ lat, lng }) => {
  if (!STREET_VIEW_ENABLED || !GOOGLE_MAPS_API_KEY) return null

  return (
    <div className="google-street-view">
      <iframe
        title="Google Street View"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0 }}
        src={`https://www.google.com/maps/embed/v1/streetview?key=${GOOGLE_MAPS_API_KEY}&location=${lat},${lng}&heading=0&pitch=0`}
        allowFullScreen
      />
    </div>
  )
}

const LocationSection = props => {
  const streetViewUrl = props.lat && props.lng
    ? `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${props.lat},${props.lng}`
    : null

  // When a specific building (bin) is selected, prefer its address over the
  // tax-lot primary address — e.g. "18 Stuyvesant Oval" instead of "240 1 Ave".
  const currentBuilding = getCurrentBuilding(
    props.propertyResult.buildings || [],
    (props.appState || {}).currentBuilding
  )
  const mapsAddress =
    currentBuilding.house_number && currentBuilding.stname
      ? `${currentBuilding.house_number} ${currentBuilding.stname}`
      : props.propertyResult.address

  return (
    <div className="location-section">
      <div className="location-section__map">
        {props.lat && props.lng ? (
          <LeafletMap
            currentGeographyType={props.appState.currentGeographyType}
            currentGeographyId={props.appState.currentGeographyId}
            changingGeographyType={props.appState.changingGeographyType}
            changingGeographyId={props.appState.changingGeographyId}
            center={[parseFloat(props.lat), parseFloat(props.lng)]}
            results={props.propertyResult}
            iconConfig="SINGLE"
            height="100%"
            zoom={17}
          />
        ) : (
          <p>No latitude / longitude coordinates were provided for this property.</p>
        )}
      </div>
      {props.lat && props.lng && (
        <StreetViewEmbed lat={props.lat} lng={props.lng} />
      )}
      <div className="text-center">
        {streetViewUrl && (
          <div>
            <BaseLink className="text-link" href={streetViewUrl} target="_blank">
              Open Street View
            </BaseLink>
          </div>
        )}
        <div>
          <BaseLink
            className="text-link"
            target="_blank"
            href={`https://google.com/maps/place/${mapsAddress}, ${boroCodeToName(
              props.propertyResult.borough
            )} ${props.propertyResult.zipcode}`}
          >
            Open Google Maps
          </BaseLink>
        </div>
      </div>
    </div>
  )
}

LocationSection.propTypes = {
  lat: PropTypes.string,
  lng: PropTypes.string,
  propertyResult: PropTypes.object,
}
LocationSection.defaultProps = {
  lat: '40.7',
  lng: '-74',
}

export default LocationSection
